import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { FakeBackendInterceptor } from "./core/helpers/fake-backend";
import { ApiPrefixInterceptor } from "./core/http/api-prefix-interceptor";
import { ErrorHandlerInterceptor } from "./core/http/error-handler.interceptor";
import { provideToastr } from "ngx-toastr";
import { provideNgxMask } from "ngx-mask";
import { BrandingService } from "./services/branding.service";
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { FeatureService } from "./services/feature.service";
import { AuthenticationService } from "./services/auth.service";

function initBranding(brandingService: BrandingService) {
  return () => brandingService.loadBranding();
}

function initStudentHolds(authenticationService: AuthenticationService) {
  return () => authenticationService.refreshStudentHolds();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initStudentHolds,
      deps: [AuthenticationService],
      multi: true,
    },

    {
      provide: APP_INITIALIZER,
      useFactory: initBranding,
      deps: [BrandingService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: FakeBackendInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    provideNgxMask(),

    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    provideToastr({ closeButton: true, preventDuplicates: true }),

    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: "en-US" },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "MM/DD/YYYY",
        },
        display: {
          dateInput: "MM/DD/YYYY",
          monthYearLabel: "MMMM YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },

    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (featureService: FeatureService) => () => {
    //     const savedUser = sessionStorage.getItem("currentUser");
    //     if (savedUser) {
    //       return featureService.refreshPlanFromServer();
    //     }
    //     return Promise.resolve();
    //   },
    //   deps: [FeatureService],
    //   multi: true,
    // },
  ],
};
